import React from "react";
import { Element } from "react-scroll";
import { FaTrophy, FaUsers, FaCode, FaMedal } from "react-icons/fa";
import "./Achievements.css";

const Achievements = () => {
  const achievements = [
    {
      category: "Hackathons",
      icon: <FaCode />,
      items: [
        "Winner - Delhi Hackathon 2024 (First Prize)",
        "Runner-up - Smart India Hackathon 2023",
        "Top 10 - International AI Challenge 2024",
      ],
    },
    {
      category: "Societies & Leadership",
      icon: <FaUsers />,
      items: [
        "Technical Head - NSUT Computer Society (2023-2024)",
        "Core Member - IEEE Student Branch NSUT",
        "Event Coordinator - TechFest 2023",
      ],
    },
    {
      category: "Academic Achievements",
      icon: <FaTrophy />,
      items: [
        "Dean's List for Academic Excellence (2023)",
        "Merit Scholarship Recipient (2022-2024)",
        "Best Project Award - Final Year Exhibition",
      ],
    },
    {
      category: "Competitions",
      icon: <FaMedal />,
      items: [
        "CodeChef 4-Star Rated Programmer",
        "LeetCode Contest Top 5% Globally",
        "Google Code Jam Regional Qualifier",
      ],
    },
  ];

  return (
    <Element name="achievements">
      <section className="achievements" style={{ padding: "2rem 2rem" }}>
        <div className="achievements-container">
          <h2 className="section-title">Achievements</h2>
          <div className="achievements-grid">
            {achievements.map((achievement, index) => (
              <div
                key={index}
                className="achievement-card"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="achievement-header">
                  <div className="achievement-icon">{achievement.icon}</div>
                  <h3>{achievement.category}</h3>
                </div>
                <ul className="achievement-list">
                  {achievement.items.map((item, itemIndex) => (
                    <li key={itemIndex}>{item}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>
    </Element>
  );
};

export default Achievements;
